import React from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import Verify from "./Verify";
import Sync from "./Sync";
import Schedule from "./Schedule";

function App() {
  return (
    <div className="App">
      <Router>
        <div>
          <Route exact path="/" component={Verify} />
          <Route path="/sync" component={Sync} />
          <Route path="/schedule" component={Schedule} />
        </div>
      </Router>
    </div>
  );
}

export default App;
